import { t } from "@lingui/macro";
import * as React from "react";
import { G, Path, Defs, ClipPath } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const SalonIcon = (props: IconProps) => {
  const clipPathId = React.useId();

  return (
    <Icon
      fill="none"
      viewBox="0 0 16 16"
      color="#001A19"
      title={t`Salon`}
      {...props}
    >
      <G clipPath={`url(#${clipPathId})`}>
        <Path
          fill="currentColor"
          d="M9.956 0S8.21.94 7.94 2.686L7.068 7.59c-.94.134-2.216.47-3.29 1.007l-.538-.537a1.905 1.905 0 0 0-2.686 0 1.905 1.905 0 0 0 0 2.686l1.007 1.007c.336.336.672 0 .672 0l1.343-1.343C4.92 9.066 6.934 9.066 6.934 9.066s0 2.015-1.343 3.358l-1.343 1.343s-.336.336 0 .672l1.007 1.007a1.905 1.905 0 0 0 2.686 0 1.905 1.905 0 0 0 0-2.686l-.537-.537c.537-1.075.873-2.351 1.007-3.291l4.903-.873C15.06 7.79 16 6.044 16 6.044L8.613 7.387 9.956 0ZM3.24 9.402l-1.343 1.343-.671-.671c-.403-.403-.403-.94 0-1.344.403-.403.94-.403 1.343 0l.671.672Zm4.03 4.03c.403.402.403.94 0 1.342-.403.403-.94.403-1.343 0l-.672-.671 1.343-1.343.672.671Zm.84-4.87a.475.475 0 1 1-.672-.671.475.475 0 0 1 .671.671Z"
        />
      </G>
      <Defs>
        <ClipPath id={clipPathId}>
          <Path fill="#fff" d="M0 0h16v16H0z" />
        </ClipPath>
      </Defs>
    </Icon>
  );
};
